// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-package-container {
    padding: 24px;
    background-color: #f5f5f5;
    min-height: 100vh;
}

.package-stats-card {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    margin-bottom: 24px;
}

.package-filters {
    background: white;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    margin-bottom: 20px;
}

.package-table-container {
    background: white;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.1);
    overflow: hidden;
}

.package-form-modal {
    background: white;
    border-radius: 8px;
    max-width: 800px;
    width: 100%;
    max-height: 90vh;
    overflow-y: auto;
}

.package-type-badge {
    display: inline-block;
    padding: 4px 12px;
    border-radius: 16px;
    font-size: 12px;
    font-weight: 600;
    text-transform: uppercase;
}

.package-type-free {
    background-color: #e8f5e8;
    color: #2e7d32;
}

.package-type-paid {
    background-color: #e3f2fd;
    color: #1976d2;
}

.package-type-custom {
    background-color: #fff3e0;
    color: #f57c00;
}

.package-type-topup {
    background-color: #f3e5f5;
    color: #7b1fa2;
}

.package-actions {
    display: flex;
    gap: 8px;
    justify-content: center;
    align-items: center;
}

.package-status-active {
    color: #2e7d32;
    font-weight: 600;
}

.package-status-inactive {
    color: #757575;
    font-weight: 600;
}

.package-price {
    font-weight: 700;
    color: #2e7d32;
}

.package-credits {
    font-weight: 600;
    color: #1976d2;
}

@media (max-width: 768px) {
    .admin-package-container {
        padding: 16px;
    }
    
    .package-filters {
        padding: 16px;
    }
    
    .package-actions {
        flex-direction: column;
        gap: 4px;
    }
} `, "",{"version":3,"sources":["webpack://./src/components/AdminPackageManagement/AdminPackageManagement.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,6DAA6D;IAC7D,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,kBAAkB;IAClB,qCAAqC;IACrC,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,qCAAqC;IACrC,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI;QACI,aAAa;IACjB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,sBAAsB;QACtB,QAAQ;IACZ;AACJ","sourcesContent":[".admin-package-container {\n    padding: 24px;\n    background-color: #f5f5f5;\n    min-height: 100vh;\n}\n\n.package-stats-card {\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    color: white;\n    margin-bottom: 24px;\n}\n\n.package-filters {\n    background: white;\n    padding: 20px;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n    margin-bottom: 20px;\n}\n\n.package-table-container {\n    background: white;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0,0,0,0.1);\n    overflow: hidden;\n}\n\n.package-form-modal {\n    background: white;\n    border-radius: 8px;\n    max-width: 800px;\n    width: 100%;\n    max-height: 90vh;\n    overflow-y: auto;\n}\n\n.package-type-badge {\n    display: inline-block;\n    padding: 4px 12px;\n    border-radius: 16px;\n    font-size: 12px;\n    font-weight: 600;\n    text-transform: uppercase;\n}\n\n.package-type-free {\n    background-color: #e8f5e8;\n    color: #2e7d32;\n}\n\n.package-type-paid {\n    background-color: #e3f2fd;\n    color: #1976d2;\n}\n\n.package-type-custom {\n    background-color: #fff3e0;\n    color: #f57c00;\n}\n\n.package-type-topup {\n    background-color: #f3e5f5;\n    color: #7b1fa2;\n}\n\n.package-actions {\n    display: flex;\n    gap: 8px;\n    justify-content: center;\n    align-items: center;\n}\n\n.package-status-active {\n    color: #2e7d32;\n    font-weight: 600;\n}\n\n.package-status-inactive {\n    color: #757575;\n    font-weight: 600;\n}\n\n.package-price {\n    font-weight: 700;\n    color: #2e7d32;\n}\n\n.package-credits {\n    font-weight: 600;\n    color: #1976d2;\n}\n\n@media (max-width: 768px) {\n    .admin-package-container {\n        padding: 16px;\n    }\n    \n    .package-filters {\n        padding: 16px;\n    }\n    \n    .package-actions {\n        flex-direction: column;\n        gap: 4px;\n    }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
